// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"HeaderTabs_buttonWrapper__cJ7K6"};